export default "__VITE_PUBLIC_ASSET__2844ac95__"